export default "__VITE_ASSET__BxdjCOnC__"